export const header = () => {




  const checkScroll = () => {
    if (window.scrollY > 50) {
      document.querySelector('header').classList.add('scroll')
    } else {
      document.querySelector('header').classList.remove('scroll')
    }
  }

  window.addEventListener('scroll', () => {
    checkScroll()
  })
  checkScroll()


  // mobile

  const burger = document.querySelector('.header__burger');
  const mobileLink1 = document.querySelectorAll('.mobile-open-2');
  const mobileLink2 = document.querySelectorAll('.mobile-open-3');
  const mobile1 = document.querySelector('.mobile-1');
  const mobile2 = document.querySelectorAll('.mobile-2');
  const mobile3 = document.querySelectorAll('.mobile-3');
  const mobileBackTo1 = document.querySelectorAll('.mobile-2 .mobile-back');
  const mobileBackTo2 = document.querySelectorAll('.mobile-3 .mobile-back');

  burger.addEventListener('click', function(e) {
    mobile1.classList.toggle('active');
    burger.classList.toggle('active');
    if (!mobile1.classList.contains('active')) {
      mobile2.forEach(function( item, index )  {
        item.classList.remove('active');
      })
      mobile3.forEach(function( item, index )  {
        item.classList.remove('active');
      })
    }
  })

  mobileLink1.forEach(function( item, index )  {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      mobile2[index].classList.add('active');
    })
  })

  mobileBackTo1.forEach(function( item, index )  {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      mobile2[index].classList.remove('active');
    })
  })

  mobileLink2.forEach(function( item, index )  {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      mobile3[index].classList.add('active');
    })
  })

  mobileBackTo2.forEach(function( item, index )  {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      mobile3[index].classList.remove('active');
    })
  })



  const thirdLinks = document.querySelectorAll('.header__menu-drop>ul>li>a')
  const thirdImages = document.querySelectorAll('.header__menu-drop-images figure')



  thirdLinks.forEach(function (link, index) {
    link.addEventListener('mouseenter', () => {
      thirdImages.forEach(function (image, index) {
        image.classList.remove('active')
      })
      thirdImages[index].classList.add('active')
    })
    // link.onMouseEnter()
  })

  const langSwitcher = document.querySelector('.lang-switcher:not(.lang-switcher--mobile)');

  if (langSwitcher) {
    const langCurrent = langSwitcher.querySelector('.lang-switcher__current');

    langCurrent.addEventListener('click', function(e) {
      e.preventDefault();
      langSwitcher.classList.toggle('active');
      langCurrent.setAttribute('aria-expanded', langSwitcher.classList.contains('active'));
    })

    document.addEventListener('click', function(e) {
      if (!langSwitcher.contains(e.target)) {
        langSwitcher.classList.remove('active');
        langCurrent.setAttribute('aria-expanded', 'false');
      }
    })

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        langSwitcher.classList.remove('active');
        langCurrent.setAttribute('aria-expanded', 'false');
      }
    })
  }

  document.querySelectorAll('a[href="#contact-us"]')?.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      window.lenis.scrollTo('#contact-us', { offset: -100 });
    });
  });
}